// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"0b1cee20","2905":"c0a9e8cc","3612":"2040381a","6988":"a449a044"}[chunkId] + ".chunk.css";
};